export default "__VITE_ASSET__AkQJyvj8__"